import { render, staticRenderFns } from "./InviteListCollaborator.vue?vue&type=template&id=0f184e22&scoped=true"
import script from "./InviteListCollaborator.vue?vue&type=script&lang=js"
export * from "./InviteListCollaborator.vue?vue&type=script&lang=js"
import style0 from "./InviteListCollaborator.vue?vue&type=style&index=0&id=0f184e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f184e22",
  null
  
)

export default component.exports